export default function Footer() {
	return (
		<footer className="footer">
			<span>
				© {`${new Date().getFullYear()}`} Asepsis Pty Ltd. All rights reserved. Powered by Asepsis. <img src={"/favicon-2.png"} width={30} alt="Asepsis" />
			</span>
		</footer>
	);
}
